
<div class="notifications">
  <div class="ui centered inline loader" :class="{'active': form.waiting}"></div>
  <dropdown v-model="form.model.read" :placeholder="'すべて'" @change="search()">
    <option value="">すべて</option>
    <option value="false">未読</option>
    <option value="true">既読</option>
  </dropdown>
  <pagination :pager="pager" :callback="search"></pagination>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>タイトル</th>
        <th>受信日時</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="ntf in notifications" :key="ntf.id">
        <td>
          <span v-if="!ntf.read" class="ui teal label">未読</span>
          <span v-else class="ui label">既読</span>
          <a class="clickable" :href="ntf.location" @click="dispatch(ntf)">{{ ntf.title }}</a>
        </td>
        <td>{{ ntf.created_at | formatDatetime }}</td>
      </tr>
    </tbody>
  </table>
</div>
